import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { BaseService } from './base/base.service';
import { AppConfig } from './app-config';
import { Observable } from 'rxjs';
import { UncontrolledEntity, ParsedImportData, ImportMappingsPayload } from '../models';
import { ObjectResponse, ListResponse } from '../interfaces';

@Injectable()
export class UncontrolledEntitiesService extends BaseService<UncontrolledEntity> {
  constructor(http: HttpClient, protected config: AppConfig) {
    super(http, config);
  }
  
  public uploadUncontrolledEntitiesFile(file: File): Observable<ObjectResponse<ParsedImportData>> {
    const headers = new HttpHeaders();
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');

    return this.http.post<ObjectResponse<ParsedImportData>>(`${this.getResourceUrl()}upload`, formData, { headers });
  }
  
  public submitUncontrolledEntitiesMappings(data: ImportMappingsPayload): Observable<ListResponse<UncontrolledEntity>> {
    return this.http.post<ListResponse<UncontrolledEntity>>(`${this.getResourceUrl()}mappings`, data);
  }

  protected getResourceUrl(): string {
    return `${this.baseUrl}uncontrolled-entities/`;
  }
}
